import React from 'react'

import { Box } from "@mui/material"
import { LoadingIconSeeker } from "@ui-seeker/core"
import { AppButtonIcon } from "@components"
import { useCreateUsersModal, useRequestUserApiKey } from "Pages/Admin/Users/@hooks"
import { editUserId, isLoadingApiKey } from "Pages/Admin/Users/@signals"


export default function actionsColumn() {

	return {
		name: 'uid',
		label: 'Actions',
		options: {
			filter: false,
			customBodyRowRenderLite: value => <ActionsCell id={value}/>,
		}
	}
}


function ActionsCell({ id }) {

	const { onOpenModal } = useCreateUsersModal()
	const { onRequestApiKey } = useRequestUserApiKey()

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5 }}>
		<AppButtonIcon
			icon="pen"
			tooltip="Edit"
			onClick={() => {
				editUserId.value = id
				onOpenModal()
			}}
		/>
		<AppButtonIcon
			icon="clone"
			tooltip="Clone"
			onClick={() => {
				editUserId.value = id
				onOpenModal(true)
			}}
		/>
		{isLoadingApiKey.value !== id && <AppButtonIcon
			icon="key"
			tooltip="Copy API Key to clipboard"
			onClick={() => {
				onRequestApiKey(id)
			}}
		/>}
		{isLoadingApiKey.value === id && <LoadingIconSeeker sx={{ fontSize: "0.8vw", }}/>}
	</Box>
}